module.exports = __webpack_public_path__ + "img/case17.c92415ff.png";